import React from "react";
import { Check } from "lucide-react";
import { PACKS, fmt } from "@/data/packs";
import { useCart } from "@/context/CartContext";
import { SectionHeading } from "@/components/PackSelection";

const rows = [
  { label: "Produits inclus", values: ["10", "15", "30"] },
  { label: "Prix", values: [fmt(100), fmt(150), fmt(300)] },
  { label: "Pour débuter", values: [true, true, true] },
  { label: "Sélection plus large", values: [false, true, true] },
  { label: "Stock plus important", values: [false, false, true] },
];

const Cell = ({ v }) => {
  if (v === true)
    return (
      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[var(--oz-nude)] text-[var(--oz-badge)] mx-auto">
        <Check className="w-3.5 h-3.5" />
      </span>
    );
  if (v === false) return <span className="text-[var(--oz-border)]">—</span>;
  return <span className="font-semibold text-[var(--oz-text)]">{v}</span>;
};

export const ComparisonTable = () => {
  const { addItem } = useCart();
  return (
    <section id="compare" className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 md:py-24 scroll-mt-20">
      <SectionHeading eyebrow="Comparatif" title="Comparez les 3 packs" />

      <div className="overflow-x-auto rounded-[1.5rem] border border-[var(--oz-border)] bg-white shadow-[0_20px_50px_-30px_rgba(26,23,20,0.3)]">
        <table data-testid="comparison-table" className="w-full min-w-[560px] text-center">
          <thead>
            <tr className="border-b border-[var(--oz-border)]">
              <th className="text-left p-5 font-medium text-[var(--oz-muted)] text-sm"></th>
              {PACKS.map((p) => (
                <th key={p.id} className={`p-5 ${p.highlight ? "bg-[var(--oz-bg-2)]" : ""}`}>
                  <div className="font-serif text-lg text-[var(--oz-text)]">{p.name}</div>
                  <div className="text-xs text-[var(--oz-muted)] mt-0.5">{fmt(p.price)}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.label} className="border-b border-[var(--oz-border)] last:border-0">
                <td className="text-left p-5 text-sm font-medium text-[var(--oz-text)]">{r.label}</td>
                {r.values.map((v, i) => (
                  <td key={i} className={`p-5 text-sm ${PACKS[i].highlight ? "bg-[var(--oz-bg-2)]" : ""}`}>
                    <Cell v={v} />
                  </td>
                ))}
              </tr>
            ))}
            <tr>
              <td className="p-5"></td>
              {PACKS.map((p) => (
                <td key={p.id} className={`p-5 ${p.highlight ? "bg-[var(--oz-bg-2)]" : ""}`}>
                  <button
                    data-testid={`compare-buy-${p.id}`}
                    onClick={() => addItem(p.id)}
                    className={`w-full inline-flex items-center justify-center px-4 py-3 rounded-full font-semibold text-xs tracking-wide transition-colors ${
                      p.highlight
                        ? "bg-[var(--oz-gold)] text-white hover:bg-[var(--oz-gold-hover)]"
                        : "bg-[var(--oz-dark)] text-white hover:bg-black"
                    }`}
                  >
                    CHOISIR MON PACK
                  </button>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
};
